module.exports = __webpack_public_path__ + "static/media/warning.2de12a0d.svg";